/**
 *
 * THIS FILE IS GENERATED. DO NOT MAKE CHANGES.
 * TEMPLATE IS IN /templates/TaskPage.tsx.
 * REGENERATED ON BUILD.
 *
 */

import { useState } from "react";
import {
  materialCells,
  materialRenderers,
} from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import { startCase } from "lodash-es";
import { useCreateTask } from "multitool-sdk-browser";
import ui from "multitool-task-math-subtract/ui";
import { Config } from "vike-react/Config";
import { Head } from "vike-react/Head";
import FileUploadControl, {
  fileUploadTester,
} from "@/components/forms/FileUploadControl";
import StatusAndResult from "@/components/StatusAndResult";
import Strategy from "@/components/Strategy";

const PACKAGE = "math";
const NAME = "subtract";

const renderers = [
  ...materialRenderers,
  //register custom renderers
  { tester: fileUploadTester, renderer: FileUploadControl },
];

export default () => {
  const [args, setArgs] = useState(ui.defaultArgs());
  const [selectedStrategies, setSelectedStrategies] = useState(ui.strategies());
  const { task } = useCreateTask({
    pkg: PACKAGE,
    name: NAME,
    args,
    runOnChange: true,
    strategies: selectedStrategies,
  });

  return (
    <div>
      <Config
        title={`Multitool : ${startCase(PACKAGE)} : ${startCase(NAME)}`}
      />
      <Head>
        <meta
          name="title"
          content={`${startCase(PACKAGE)} : ${startCase(NAME)} by Multitool.xyz`}
        />
        <meta
          name="description"
          content={`${ui.description} : Multitool.xyz offers a collection of free online utilities including file conversions, image filters, calculators, and more`}
        />
        <meta
          name="keywords"
          content={`${startCase(PACKAGE)},  ${startCase(NAME)},  Multitool.xyz, Multitool, file conversion, online calculator, free utilities, APIs, file tools, unit converters, free online tools`}
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Multitool.xyz" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <h1>{ui.description}</h1>
      <Strategy allowed={ui.strategies()} onChange={setSelectedStrategies} />
      <JsonForms
        uischema={ui.UISchema}
        schema={ui.ArgsSchema}
        data={args}
        renderers={renderers}
        cells={materialCells}
        onChange={({ data }) => setArgs(data)}
      />
      <StatusAndResult task={task} />
    </div>
  );
};
